import * as actionTypes from '../actionTypes';
import axios from 'axios';


export const fetchCompanyInfoSuccess = (companyData) =>{
    return{
        type: actionTypes.COMPANY_INFO_ACQUIRED,
        data: companyData
    }
}

export const fetchCompanyInfoFailure = (error) =>{
    return{
        type: actionTypes.COMPANY_INFO_ACQUISITION_FAILURE,
        error
    }
}

export const fetchCompanyInfoByRegion = () => {
    return dispatch => {
        axios.get('company/GetAllRegionCompanyInfo')
            .then(response => {
                const companyData = response.data;
                dispatch(fetchCompanyInfoSuccess(companyData));
        }).catch(error=>{
            dispatch(fetchCompanyInfoFailure(error));
        }
        );
    }

};

export const getRegionSelectedSuccess = (regionNameSelected) =>{
    return{
        type: actionTypes.REGION_SELECTED_ACQUIRED,
        data: regionNameSelected
    }
}

export const getRegionSelectedFailure = (error) =>{
    return{
        type: actionTypes.REGION_SELECTED_ACQUISITION_FAILURE,
        error
    }
}

export const getRegionSelected = () => {
    return dispatch => {
        axios.get('regions/getRegionSelected')
        .then(response => {
            const regionNameSelected = response.data.data.name;
            dispatch(getRegionSelectedSuccess(regionNameSelected));
        }).catch(error =>{
            dispatch(getRegionSelectedFailure(error));
        });
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/TopBar/TopBarAction.js